/* eslint-disable no-underscore-dangle */
import VersionUtil from './versionUtil';

const _geekAndroidWebView = new RegExp('NetEaseEdu.*ap.+; geek;( athena;)? (.*); channel=(.*)', 'i');
const _geekIosWebView = new RegExp('NetEaseEdu.*iphone; geek;( athena;)? (.*); channel=(.*)', 'i');

const MobileUtil = {
  /**
   * 获取 userAgent
   */
  getUserAgent(): string {
    return window.navigator.userAgent;
  },

  /**
   * 判断是否是该平台
   */
  is(platform: string): boolean {
    const regx = new RegExp(`(${platform})`, 'ig');
    const _userAgent = this.getUserAgent();
    return regx.test(_userAgent);
  },

  /**
   * 判断是否是移动端
   */
  isMobileAll(): boolean {
    const _userAgent = this.getUserAgent();
    const _regx = new RegExp('(iPhone|iPod|Android|BlackBerry|mobile|Windows Phone)', 'ig');
    return _regx.test(_userAgent);
  },

  /**
   * 判断是否是 IPad 端
   * @method isIpad
   * @param {Void}
   * @return {Boolean}
   */
  isIPad(): boolean {
    return this.is('iPad');
  },

  /**
   * 判断是否是android pad端
   * @method isAndroidPad
   * @param {Void}
   * @return {Boolean}
   */
  isAndroidPad(): boolean {
    return this.is('apad');
  },

  /**
   * 判断是否是iPhone端
   */
  isIPhone(): boolean {
    const _userAgent = this.getUserAgent();
    return _userAgent.indexOf('iPhone') > -1;
  },

  /**
   * 判断是否是iPhoneX端
   */
  isIPhoneX(): boolean {
    if (!this.isIPhone()) {
      return false;
    }
    return (window.screen.availHeight === 812) && (window.screen.availWidth === 375);
  },

  /**
   * 判断是否是android端
   * @method isAndroid
   * @param {Void}
   * @return {Boolean}
   */
  isAndroid(): boolean {
    const _userAgent = this.getUserAgent();
    return _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Adr') > -1;
  },

  /**
   * 判断是否是微信（排除windows PC微信）打开
   */
  isWeixin(): boolean {
    return this.is('micromessenger') && !this.is('windowswechat');
  },

  /**
   * 判断是否卡搭app
   */
  isGeekApp(): boolean {
    return this.is('geek') && !this.is('athena');
  },

  /**
   * 判断是否卡搭iphone app
   */
  isIOSPhoneApp(): boolean {
    return this.isGeekApp() && this.isIPhone();
  },

  /**
   * 判断是否卡搭安卓phone app
   */
  isAndroidPhoneApp(): boolean {
    return this.isGeekApp() && this.isAndroid() && !this.isAndroidPad();
  },

  /**
   * 判断是否卡搭手机端 app
   */
  isGeekPhoneApp(): boolean {
    return this.isIOSPhoneApp() || this.isAndroidPhoneApp();
  },

  /**
   * 获取android app 的版本号
   */
  getAndroidAppVersion(): string {
    const agent = this.getUserAgent().toLowerCase();
    return (agent.match(_geekAndroidWebView) as string[])[2];
  },

  /**
   * 获取ios app 的版本号
   */
  getIosAppVersion(): string {
    const agent = this.getUserAgent().toLowerCase();
    return (agent.match(_geekIosWebView) as string[])[2];
  },

  /**
 * 判断是否高于指定安卓和ios版本
 * @param {String} androidVersion
 * @param {String} iosVersion
 * @returns {Boolean}
 * @private
 */
  isSupportByVersion(androidVersion = '3.0.0', iosVersion = '3.0.0'): boolean {
    if (this.isAndroid()) {
      return VersionUtil._$versionCompare(this.getAndroidAppVersion(), androidVersion) >= 0;
    } if (this.isIPad() || this.isIPhone()) {
      return VersionUtil._$versionCompare(this.getIosAppVersion(), iosVersion) >= 0;
    }
    return false;
  },

  /**
   * 判断是否在精品课App中打开
   */
  isInCourseApp() {
    return this.is('youdaoCourse');
  },

  /**
   * 判断是否是小程序端
   */
  isMiniprogram(): boolean {
    return this.is('miniprogram');
  },

  /**
   * 判断是否在 ledu app
   * "NetEaseEdu (iphone; geek; athena;" + appVersion + "; channel=netease; imei=" + deviceID + "
   */
  isLeduApp(): boolean {
    return this.is('athena');
  }
};

export default MobileUtil;
